import React from 'react';
import './Header.css';

const Header = ({ onMenuToggle, bibleVerse }) => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <button className="menu-toggle" onClick={onMenuToggle}>
            <span></span>
            <span></span>
            <span></span>
          </button>
          <h1 className="app-title">Property Utility Calculator</h1>
        </div>
        
        {bibleVerse && (
          <div className="bible-verse">
            <div className="verse-text">"{bibleVerse.text}"</div>
            <div className="verse-reference">- {bibleVerse.reference}</div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;